import React from 'react';

import { Container, Navbar } from 'react-bootstrap';
import ModernNavButton from '../elements/ModernNavButton';
import ModernLogoutButton from '../elements/ModernLogoutButton';
import { useAuth } from '../context/AuthContext';
import './ModernNavbar.css';



const NavContainer = () => {

    const {user} = useAuth();

    return ( 
        <Navbar className="modern-navbar">
        <Container fluid>
           <ModernNavButton></ModernNavButton>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <div className="user-section">
              <div className="user-info">
                <div className="user-avatar">
                  {user.email.charAt(0).toUpperCase()}
                </div>
                <div className="user-email">
                  {user.email}
                </div>
              </div>
              <ModernLogoutButton></ModernLogoutButton>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
     );
}
 
export default NavContainer;